const INTENSITY_COLORS = ["#8D99AE", "#F4A261", "#E76F51", "#D62828", "#9D0208"];

export default function IntensityMeter({ value = 0, size = "md" }) {
  // value is 0..5 (can be fractional)
  const segments = [1, 2, 3, 4, 5];
  const h = size === "lg" ? "h-3" : size === "sm" ? "h-1.5" : "h-2";
  return (
    <div
      data-testid="intensity-meter"
      className="flex items-center gap-1.5 w-full"
      aria-label={`Intensity ${value} out of 5`}
    >
      {segments.map((s) => {
        const filled = value >= s - 0.5;
        const partial = !filled && value >= s - 1 + 0.1;
        const color = INTENSITY_COLORS[Math.min(4, Math.max(0, Math.round(value) - 1))];
        return (
          <div
            key={s}
            className={`flex-1 ${h} rounded-full overflow-hidden bg-[#E7E3DA]`}
          >
            <div
              className="h-full transition-all duration-500"
              style={{
                width: filled ? "100%" : partial ? `${(value - (s - 1)) * 100}%` : "0%",
                background: color,
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
